<template>
    <el-dialog
        title="提示"
        :visible.sync="value"
        :close-on-press-escape="false"
        width="40%"
        :show-close="false"
        :close-on-click-modal="false"
        @close="close">
            <div class="notice-content">
                <p>
                    根据《税法》规定：网红/达人直播、销售，涉及的影视、演出、表演、广告、经纪服务等项目，属于个人所得税法实施条例中列明的劳务报酬的项目，应当按照劳务报酬征收个人所得税。因此，在抖音、快手上销售课程收益同样需要缴税。个人所得税按应纳所得额划分，<span class="red">最高为45%！！！</span>
                </p>
                <p>
                    为了保证广大达人的切身利益，减少达人个人处理税务问题的麻烦，豆包知道平台将<span class="red">全额承担</span>达人代缴税款，并提供完税证明，开通代缴税服务后<span class="red">平台抽佣为10%！</span>
                </p>
                <div class="notice-img">
                    <el-image style="width: 200px; height: 150px" :src="item" :preview-src-list="[item]" v-for="(item, index) in list" :key="index" :z-index="10000"></el-image>
                </div>
                <div class="notice-checked">
                    <el-checkbox v-model="checked">同意开通</el-checkbox>
                </div>
            </div>
        <span slot="footer" class="dialog-footer">
            <el-button type="primary" @click="sure" :disabled="!checked">确认</el-button>
        </span>
    </el-dialog>
</template>
<script>
export default {
    props: {
        value: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            list: [
                'http://img-dbzd.doubaozhidao.com/20220815/r4NZfRpftcGWn6E2ANfyHedcfK7S7d5r1660554235251.png?x-oss-process=image/quality,q_80/format,png',
                'http://img-dbzd.doubaozhidao.com/20220815/RP6CMtDdZCTkdGSapxTnMjkA2ZXHpJKB1660554235244.png?x-oss-process=image/quality,q_80/format,png'
            ],
            checked: true
        }
    },
    methods: {
        close() {
            this.$emit('input', false)
        },
        sure() {
            this.$emit('input', false)
            this.$emit('sure')
        }
    }
}
</script>
<style lang="less">
    .notice-content {
        p {
            color: #333;
            text-indent: 20px;
            margin-bottom: 12px;
            .red {
                font-weight: bold;
                color: red;
            }
        }
        .notice-checked {
            display: flex;
            justify-content: center;
        }
    }
</style>
